module.exports = __webpack_public_path__ + "img/map.ea92a20b.svg";